import { render, staticRenderFns } from "./VariantAttributeSelection.vue?vue&type=template&id=0040e562&scoped=true&"
import script from "./VariantAttributeSelection.vue?vue&type=script&lang=js&"
export * from "./VariantAttributeSelection.vue?vue&type=script&lang=js&"
import style0 from "./VariantAttributeSelection.vue?vue&type=style&index=0&id=0040e562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0040e562",
  null
  
)

export default component.exports